import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

import type { TestimonialNodeProps } from '.';
import styles from './Tile.module.scss';

/**
 * Testimonial node component for the Tile display type.
 */

const TestimonialNodeTile = (props: TestimonialNodeProps) => {
  const { quote, name, position } = props;

  return (
    <Flex gap="sm" padding="md" width={12} direction="column" className={styles.tileWrapper}>
      <RichText value={quote} marginBottom="sm" />
      <Flex.Item>
        {name && (
          <Text level="body-xs" transform="uppercase" marginBottom={4}>
            {name}
          </Text>
        )}
        {position && (
          <Text
            level="body-xs"
            transform="uppercase"
            marginBottom="none"
            className={styles.position}
          >
            {position}
          </Text>
        )}
      </Flex.Item>
    </Flex>
  );
};

export default TestimonialNodeTile;
